'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _content = require('../resources/content.json');

var _content2 = _interopRequireDefault(_content);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var MPPNotification = function (_React$Component) {
  _inherits(MPPNotification, _React$Component);

  function MPPNotification(props) {
    _classCallCheck(this, MPPNotification);

    var _this = _possibleConstructorReturn(this, (MPPNotification.__proto__ || Object.getPrototypeOf(MPPNotification)).call(this, props));

    _this.state = {
      isShown: false
    };
    _this.setClose = _this.setClose.bind(_this);
    _this.hideComponent = _this.hideComponent.bind(_this);
    _this.showComponent = _this.showComponent.bind(_this);
    return _this;
  }

  _createClass(MPPNotification, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (typeof Storage !== 'undefined') {
        if (!this.props.content.close.localStorage || !localStorage.getItem(this.props.content.close.localStorage)) {
          this.showComponent();
        }
      } else {
        this.showComponent();
      }
    }
  }, {
    key: 'setClose',
    value: function setClose(event) {
      event.preventDefault();

      if (typeof Storage !== 'undefined') {
        localStorage.setItem(this.props.content.close.localStorage, 'true');
      }
      this.hideComponent();
    }
  }, {
    key: 'hideComponent',
    value: function hideComponent() {
      this.setState({ isShown: false });
    }
  }, {
    key: 'showComponent',
    value: function showComponent() {
      this.setState({ isShown: true });
    }
  }, {
    key: 'renderClose',
    value: function renderClose(close) {
      return (
        /* eslint-disable-next-line */
        _react2.default.createElement('a', {
          href: '#',
          className: 'pp-notification__close',
          role: 'button',
          'aria-label': close.text,
          title: close.text,
          onClick: this.setClose,
          'data-pa-click': 'Ntfn-clostBtn-close'
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$content = this.props.content,
          paragraph = _props$content.paragraph,
          close = _props$content.close;
      var _props$config = this.props.config,
          customClass = _props$config.customClass,
          id = _props$config.id;

      var theme = this.props.config.theme || _content2.default.config.theme;
      var MPPNotificationClasses = (0, _classnames2.default)('pp-notification', theme, customClass);
      if (!this.state.isShown) {
        return null;
      }
      return _react2.default.createElement(
        'section',
        { id: id, className: MPPNotificationClasses, 'data-building-block': 'organism' },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              MPPNotification.renderMPPNotification(paragraph),
              this.renderClose(close)
            )
          )
        )
      );
    }
  }], [{
    key: 'renderMPPNotification',
    value: function renderMPPNotification(paragraph) {
      return _react2.default.createElement(
        'p',
        { className: 'pp-notification__paragraph legal-text' },
        htmlToReactParser.parse(paragraph.text)
      );
    }
  }]);

  return MPPNotification;
}(_react2.default.Component);

exports.default = MPPNotification;


MPPNotification.propTypes = {
  content: _propTypes2.default.shape({
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string
    }),
    close: _propTypes2.default.shape({
      text: _propTypes2.default.string,
      localStorage: _propTypes2.default.string
    })
  }),
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    theme: _propTypes2.default.string,
    customClass: _propTypes2.default.string
  })
};

MPPNotification.defaultProps = _content2.default;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/notification/jsx/MPPNotification.js
// module id = 1121
// module chunks = 4